import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MapInfoToggle',
  props: {
    value: { type: Boolean },
    label: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
	(event: 'input', value: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	value: boolean
	label: string
};





const model = computed({
	get() {
		return props.value
	},
	set(value: boolean) {
		emit('input', value)
	},
})

return { __sfc: true,props, emit, model }
}

})